export interface QCReportProcessingRequest {

    /** The id. */
    id: string;

    /** The action. */
    action: Action;

    /** The comment. */
    comment: string;

    /** the report identifier */
    reportIdentifier: string;

    labIdentifier: string;

    approvalDate: string;

    approvalTime: string;

    approvedBy: string;

    plateName: string;

    plateQCStatus: string;

    plateQCComment: string;

    approvalMessageLocation: string;
}
export enum Action {
    TRASHED = "trashed",
    RELEASED = "released"
}